import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";

import { AuthnLayout } from "@wc/domain/authn";
import { CenteredPageLayout, HomeLayout, FeedLayout } from "@wc/domain/layouts";
import { OrgSettingsLayout, ActiveOrgLayout } from "@wc/domain/organizations";
import { TeamSettingsLayout } from "@wc/domain/teams";

import Feed from "./feed";
import Home from "./home";
import Login from "./home/login";
import Orgs from "./home/orgs";
import OrgIndex from "./home/orgs/[orgId]";
import OrgInfoPage from "./home/orgs/[orgId]/info";
import OrgMembers from "./home/orgs/[orgId]/members";
import OrgOverview from "./home/orgs/[orgId]/overview";
import Teams from "./home/orgs/[orgId]/teams";
import TeamDetail from "./home/orgs/[orgId]/teams/[teamId]";
import TeamInfoPage from "./home/orgs/[orgId]/teams/[teamId]/info";
import TeamMembers from "./home/orgs/[orgId]/teams/[teamId]/members";
import TeamOverview from "./home/orgs/[orgId]/teams/[teamId]/overview";
import InviteRedemption from "./invite/[token]";
import Profile from "./profile";

/**
 * @returns {React.ReactElement} The Router Provider for the app
 */
export default function WCRouter() {
  const router = createBrowserRouter([
    {
      path: "/login",
      element: (
        <CenteredPageLayout>
          <Login />
        </CenteredPageLayout>
      ),
    },
    {
      path: "/invite/:token",
      element: <InviteRedemption />,
    },
    {
      element: <AuthnLayout />,
      children: [
        {
          path: "/",
          element: (
            <ActiveOrgLayout>
              <HomeLayout>
                <Home />
              </HomeLayout>
            </ActiveOrgLayout>
          ),
        },
        {
          path: "/feed",
          element: (
            <ActiveOrgLayout>
              <FeedLayout>
                <Feed />
              </FeedLayout>
            </ActiveOrgLayout>
          ),
        },
        {
          element: (
            <CenteredPageLayout>
              <OrgSettingsLayout />
            </CenteredPageLayout>
          ),
          children: [
            {
              path: "/orgs/:orgId",
              element: <OrgIndex />,
            },
            {
              path: "/orgs/:orgId/overview",
              element: <OrgOverview />,
            },
            {
              path: "/orgs/:orgId/info",
              element: <OrgInfoPage />,
            },
            {
              path: "/orgs/:orgId/members",
              element: <OrgMembers />,
            },
            {
              path: "/orgs/:orgId/teams",
              element: <Teams />,
            },
            {
              element: <TeamSettingsLayout />,
              children: [
                {
                  path: "/orgs/:orgId/teams/:teamId",
                  element: <TeamDetail />,
                },
                {
                  path: "/orgs/:orgId/teams/:teamId/overview",
                  element: <TeamOverview />,
                },
                {
                  path: "/orgs/:orgId/teams/:teamId/info",
                  element: <TeamInfoPage />,
                },
                {
                  path: "/orgs/:orgId/teams/:teamId/members",
                  element: <TeamMembers />,
                },
              ],
            },
          ],
        },
        {
          path: "/orgs",
          element: (
            <CenteredPageLayout>
              <Orgs />
            </CenteredPageLayout>
          ),
        },
        {
          path: "/profile",
          element: (
            <CenteredPageLayout>
              <Profile />
            </CenteredPageLayout>
          ),
        },
      ],
    },
  ]);

  return <RouterProvider router={router} />;
}
